module.exports = __webpack_public_path__ + "img/DESC_SORT.bb03d870.svg";